/*jshint esnext: true */
/*global jQuery, dis */

/* DIS/PLAY Script
 Author's name: Lars Munkholm
 Modified by:
 Client name: Danske Regioner
 Date of creation: February 10, 2016
 */



window.initMap = function(){};
(function ($, dis) { // jshint ignore:line
	"use strict";


	function init() {
		dis.inits = {
			menu: new dis.Menu(),
			mainSearch: new dis.MainSearch({container: ".main-search"}),
			okportalSearch: new dis.OkportalSearch({container: ".okportal-search"}),
			okportalNumerisk: new dis.OkportalNumerisk({container: ".okportal-numerisk"}),
			okportalFavorites: new dis.OkportalFavorites({container: ".okportal-favorites"}),
			articlesList: new dis.ArticlesList({container: ".articles-list"}),
			socialSharing: new dis.SocialSharing({container: ".social-sharing"}),
			googleMaps: new dis.GoogleMaps({container: ".google-maps-container"}),
			jqueryModal: new dis.JqueryModal(),
			imageSlider: new dis.ImageSlider(),
			accordion: new dis.Accordion(),
			imagehandler: new dis.ImageHandler(),
			vac: new dis.Vac({container: "body"}),
		};

		// Make SVGs work in IE and Edge (seriously, Microsoft? Edge? WTF)
		window.svg4everybody();

		// See further options at: http://cubiq.org/add-to-home-screen
		window.addToHomescreen({
			maxDisplayCount: 1,
			modal: true,
			lifespan: 0
		});
	}


	dis.BaseModule.prototype.onReady(init);

}(jQuery, dis));